import React, { useState, useContext, useEffect, useMemo, useRef } from "react";
import { DetailsModal } from "../../grid/DetailsModal";
import { Row, Col } from "react-bootstrap";
import { GridColumn } from "@progress/kendo-react-grid";
import SharedMainSelectableClientGrid from "shared/components/grids/clientGrid/SharedMainSelectableClientGrid";
import useGridButtons from "shared/components/grids/hooks/useGridButtons";
import {
    MoneyCell,
    AggregateMoneyFooterCell,
    TooltipCell,
} from "../../grid/Kendo/CustomKendoGridCells";
import {
    DefaultBooleanOrShortWidthColumnWidth,
} from "../../grid/Kendo/KendoGridAndColumnConstants";
import { IsNullOrEmpty } from "shared/helpers/NullEmptyHelpers";
import { UserContext } from "shared/context/UserContext";
import { IgnoreModal } from "shared/components/ignoreModal/IgnoreModal";
import { IgnoreBody } from "shared/components/ignoreModal/IgnoreBody";
import PrescriptionDetailsModal from "./PrescriptionDetailsModal";
import UnAppliedCashPrescriptionDetailsModal from "./UnappliedCashPrescriptionDetailsModal";
import ErrorHandler from "../../core/ErrorHandler";
import { useReactQueryHelpers } from "shared/hooks/useReactQueryHelpers";
import PaymentExceptionDirectExport from "./PaymentExceptionDirectExport";

export default function PaymentExceptionDetailModal(props) {

    const { submittedFormData, selectedPayers, title, show, onClose, passedProps, tabName } = props;
    const { invalidateReactQueryKey } = useReactQueryHelpers();
    const { AddGridButton, gridButtons } = useGridButtons();
    const [detailsGridAggregates, setDetailsGridAggregates] = useState([]);
    // let DETAILS_DATA_ITEM_KEY = "clid";
    let DETAILS_DATA_ITEM_KEY = tabName === "UnappliedCash" ? "pyidsList" : "clid";
    const [refreshDetailGrid, setRefreshDetailGrid] = useState(false);
    const userContext = useContext(UserContext);
    const clientGridRef = useRef();
    const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
    const [detailModelShow, setDetailModelShow] = useState(show);
    const [selectedNcpdpIgnoreModalText, setSelectedNcpdpIgnoreModalText] = useState("");
    const [selectedRxIgnoreModalText, setSelectedRxIgnoreModalText] = useState("");
    const [selectedClid, setSelectedClid] = useState("");
    const [selectedPbid, setSelectedPbid] = useState("");
    const [selectedRxNumber, setSelectedRxNumber] = useState("");
    const [selectedDispensedDate, setSelectedDispensedDate] = useState("");
    const [showIgnoreModal, setShowIgnoreModal] = useState(false);
    const [isIgnoreClaimsFormDisabled, setIsIgnoreClaimsFormDisabled] = useState(false);
    const [IgnoreError, setIgnoreError] = useState({});
    const [detailError, setDetailError] = useState({});

    const [selectedClidsToIgnore, setSelectedClidsToIgnore] = useState("");
    const [selectedClidsToExport, setSelectedClidsToExport] = useState("");
    const [selectedItems, setSelectedItems] = useState("");
    const [directExportType, setDirectExportType] = useState(false);
    const [directExportIsProcessing, setDirectExportIsProcessing] =
        useState(false);
    const [isDirectExportDataLoading, setIsDirectExportDataLoading] =
        useState(false);


    useEffect(() => {
        AddGridButton(
            "Ignore Selected Claims",
            openIgnoreModalWithSelectedClaimsButton,
            true
        );
        AddGridButton(
            "Export details for selected claims",
            exportDetailsWithSelectedClaims,
            true,
            "Excel,CSV"
        );
        setDetailModelShow(show ? true : false);
    }, []);
    useEffect(() => {
        setDetailModelShow(show ? true : false);
    }, [show])

    function exportDetailsWithSelectedClaims(clickedItem) {
        const selectedClaims = clientGridRef.current
            ? clientGridRef.current.GetSelectedGridDataKeys()
            : null;

        let clidsToIgnore = selectedClaims.join(",");
        let selectedDataItems = getSelectedDataItem(selectedClaims);

        console.log(selectedDataItems);
        console.log(selectedClaims);
        
        setSelectedClidsToExport(clidsToIgnore);
        setDirectExportType(clickedItem.toLowerCase());
        setDirectExportIsProcessing(true);
        setSelectedItems(selectedDataItems);
    }

    function getSelectedDataItem(selectedClaims) {
        var selectedItem = []
        const allData = clientGridRef.current
            ? clientGridRef.current.GetAllGridData()
            : [];
        selectedClaims.forEach(element => {
            allData.forEach(item => {
                if (item[DETAILS_DATA_ITEM_KEY] === element) {
                    selectedItem.push(item);
                }
            })
        });
        return selectedItem;
    }

    function openIgnoreModalWithSelectedClaimsButton(row) {

        if (tabName === "UnappliedCash") {
            console.log("This is an Unapplied Cash tab - Ignore action is not applicable.");
        }

        const selectedClaims = clientGridRef.current
            ? clientGridRef.current.GetSelectedGridDataKeys()
            : null;
        var clidsToIgnore = selectedClaims.join(",");
        setSelectedClidsToIgnore(clidsToIgnore);

        //NOTE TODO: This needs to be modified to handle distinguishing between payments and claims
        //this will send the same info but it will alter the SP that's called
        openIgnoreModalWithSelectedClaims(row);
    }

    const overPaymentDetailApiParams = useMemo(() => {

        if (IsNullOrEmpty(userContext.email)) {
            return {};
        }

        if (!submittedFormData) {
            return {};
        }
        if (!selectedPayers) {
            return {};
        }
        if (selectedPayers.length === 0) {
            return {};
        }

        let params = {
            user: userContext.email,
            fromDate: submittedFormData.fromDate,
            toDate: submittedFormData.toDate,
            locations: submittedFormData.locations,
            payers: selectedPayers.toString(),
            dateType: submittedFormData.dateType,
            checkNumber: submittedFormData.checkNumber,
            showArchiveRemitsOnly: submittedFormData.showArchiveRemitsOnly,
            includeNetZeroClaims: submittedFormData.includeNetZeroClaims ? submittedFormData.includeNetZeroClaims : false
        }
        return params;
    }, [selectedPayers]);

    function exportDetailsAPI() {
        if (tabName === 'ReversedClaims') {
            return "api/PaymentException/GetReversedClaimsExport";
        }
        if (tabName === 'Overpayments') {
            return "api/PaymentException/GetOverpaymentExport";
        }
        if (tabName === 'UnappliedCash') {
            return "api/PaymentException/GetUnappliedCashExport";
        }
    }

    const overPaymentDetailExportApiParams = useMemo(() => {

        if (IsNullOrEmpty(userContext.email)) {
            return {};
        }

        if (!submittedFormData) {
            return {};
        }
        if (!selectedPayers) {
            return {};
        }
        if (selectedPayers.length === 0) {
            return {};
        }

        if (tabName === 'UnappliedCash') {
            var paramsList = [];
            for (let i = 0; i < selectedItems.length; i++) {
                var item = selectedItems[i];
                var param = {
                    user: userContext.email,
                    fromDate: submittedFormData.fromDate,
                    toDate: submittedFormData.toDate,
                    locations: submittedFormData.locations,
                    payers: selectedPayers.toString(),
                    dateType: submittedFormData.dateType,
                    checkNumber: submittedFormData.checkNumber,
                    showArchiveRemitsOnly: submittedFormData.showArchiveRemitsOnly,
                    includeNetZeroClaims: submittedFormData.includeNetZeroClaims ? submittedFormData.includeNetZeroClaims : false,
                    RxNumber: item.rxNumber,
                    dispensedDate: item.dispensedDate
                }
                paramsList.push(param);
            }
            return {
                data: JSON.stringify(paramsList)
            }
        }


        let params = {
            user: userContext.email,
            fromDate: submittedFormData.fromDate,
            toDate: submittedFormData.toDate,
            locations: submittedFormData.locations,
            payers: selectedPayers.toString(),
            dateType: submittedFormData.dateType,
            checkNumber: submittedFormData.checkNumber,
            showArchiveRemitsOnly: submittedFormData.showArchiveRemitsOnly,
            Clids: selectedClidsToExport
        }
        return params;
    }, [selectedClidsToExport, selectedItems]);

    const sendDetailAggregatesToParent = (aggregatesFromPaymentsGridSkeleton) => {
        setDetailsGridAggregates(aggregatesFromPaymentsGridSkeleton.data);
    };

    const DetailsGridAggregateMoneyFooterCell = (props) => {
        var options = {
            aggregateData: detailsGridAggregates,
        };

        return AggregateMoneyFooterCell(props, options);
    };
    const CustomDetailsActionCell = (props) => (
        <CustomDetailsCell {...props} color={"#015CAB"} />
    );

    function openIgnoreModalWithSelectedClaims(row) {
        if (row.clid) {
            setSelectedNcpdpIgnoreModalText(row.ncpdp);
            setSelectedRxIgnoreModalText(row.rxNumber);
        } else {
            setSelectedNcpdpIgnoreModalText("All Selected");
            setSelectedRxIgnoreModalText("All Selected");
        }
        setShowIgnoreModal(true);
        setDetailModelShow(false);
    }

    const CustomDetailsCell = (props) => {
        function onPrescriptionClick() {
            getPrescriptionDetail(props.dataItem.clid);
            setSelectedPbid(props.dataItem.pbid);
            setSelectedRxNumber(props.dataItem.rxNumber);
            setSelectedDispensedDate(props.dataItem.dispensedDate);
        }
        function onIgnoreClick() {
            var clidsToIgnore = props.dataItem.clid;
            setSelectedClidsToIgnore(clidsToIgnore);
            openIgnoreModalWithSelectedClaims(props.dataItem);
        }

        return (
            <td
                {...props.tdProps}
                colSpan={1}
                style={{
                    color: props.color,
                }}
            >
                <a
                    className="action-cell"
                    onClick={onPrescriptionClick}
                    data-testid={"action-" + props.key}
                >
                    Prescription Details
                </a>
                <br />
                {tabName != "UnappliedCash" &&
                    <a
                        className="action-cell"
                        onClick={onIgnoreClick}
                        data-testid={"action-" + props.key}
                    >
                        Ignore
                    </a>
                }
            </td>
        );
    };

    const onIgnoreClaimsSaveButtonCallback = () => {
        setIsIgnoreClaimsFormDisabled(true);

    };

    function setIgnoreActionCompletedMessage() {
        setDetailError({
            status: 200,
            Message: "Selected items have been ignored!",
        });
        setTimeout(() => {
            setDetailError({});
        }, 3600);
    }

    function MainGridAPIUrl() {
        if (tabName === "Overpayments") {
            return "api/PaymentException/GetOverpaymentsSummary";
        }
        else if (tabName === "ReversedClaims") {
            return "api/PaymentException/GetReversedClaimsSummary";
        }
        else if (tabName === "UnappliedCash") {
            return "api/PaymentException/GetUnappliedCashSummary";
        }
    }
    function DetailGridAPIUrl() {
        if (tabName === "Overpayments") {
            return "api/PaymentException/GetOverpaymentsDetails";
        }
        else if (tabName === "ReversedClaims") {
            return "api/PaymentException/GetReversedClaimsDetails";
        }
        else if (tabName === "UnappliedCash") {
            return "api/PaymentException/GetUnappliedCashDetails";
        }
    }

    function DetailGridAggregateSetting() {
        if (tabName === "UnappliedCash") {
            return [
                { aggregate: "sum", field: "adjudicatedCopay" },
                { aggregate: "sum", field: "difference" },
                { aggregate: "sum", field: "paid" }
            ];
        }
        else {
            return [{ aggregate: "sum", field: "adjudicated" },
            { aggregate: "sum", field: "adjudicatedCopay" },
            { aggregate: "sum", field: "difference" },
            { aggregate: "sum", field: "paid" }
            ];
        }
    }

    const onIgnoreClaimSuccessCallback = (response) => {
        setShowIgnoreModal(false);

        setRefreshDetailGrid(refreshDetailGrid ? false : true);

        invalidateReactQueryKey(MainGridAPIUrl());
        invalidateReactQueryKey(DetailGridAPIUrl());
        setDetailModelShow(true);
        setIgnoreActionCompletedMessage();
        setIsIgnoreClaimsFormDisabled(false);
    };

    function getPrescriptionDetail(clid) {
        setSelectedClid(clid);
        setDetailModelShow(false);
        setShowPrescriptionModal(true);
    }
    function handleCancelIgnoreClick() {
        setShowIgnoreModal(false);
        setDetailModelShow(true);
    }
    function handlePrescriptionDetailClose() {
        setShowPrescriptionModal(false);
        setDetailModelShow(true);
    }
    function handleCellClick(row, column) {
    }
    let detailsGridUseQueryOptions = { refetchOnWindowFocus: false };
    return (
        <div>
            <DetailsModal
                title={title}
                show={detailModelShow}
                handleClose={onClose}
            >
                <div className="fee-and-adjustment-detail-summary-wrapper">
                    <ErrorHandler
                        error={detailError}
                        onClose={() => {
                            setDetailError({});
                        }}
                    />
                    <br />

                    <Row>
                        <Col md={12} className="tight-grid multi-line-filter">
                            <SharedMainSelectableClientGrid
                                ref={clientGridRef}
                                apiGetEndpoint={DetailGridAPIUrl()}
                                apiParameters={overPaymentDetailApiParams}

                                //data={detailData}
                                aggregateColumnSettings={DetailGridAggregateSetting()}
                                sendAggregatesParentCallback={sendDetailAggregatesToParent}
                                exportFileNamePrefix={"PaymentException" + tabName + "details"}
                                isSelectable={true}
                                dataItemKey={DETAILS_DATA_ITEM_KEY}
                                secondsBeforeLoadingSpinner={5}
                                refreshGrid={refreshDetailGrid}
                                useQueryOptions={detailsGridUseQueryOptions}

                                gridButtons={gridButtons}
                                dateFormattingColumns={["dispensedDate", "transactionDate"]}
                            >
                                <GridColumn
                                    key={"Action"}
                                    field={"Action"}
                                    title={"Action"}
                                    width={DefaultBooleanOrShortWidthColumnWidth()}
                                    filterable={false}
                                    cells={{
                                        data: CustomDetailsActionCell,
                                    }}
                                    headerCell={TooltipCell}
                                />
                                <GridColumn
                                    key={"ncpdp"}
                                    field={"ncpdp"}
                                    title={"NCPDP"}
                                    width={DefaultBooleanOrShortWidthColumnWidth()}
                                    headerCell={TooltipCell}
                                />
                                <GridColumn
                                    key={"rxNumber"}
                                    field={"rxNumber"}
                                    title={"Rx #"}
                                    filter={"text"}
                                    width={DefaultBooleanOrShortWidthColumnWidth()}
                                    headerCell={TooltipCell}
                                />
                                <GridColumn
                                    key={"dispensedDate"}
                                    field={"dispensedDate"}
                                    title={"Dispensed Date"}
                                    filter={"date"}
                                    format="{0:d}"
                                    width={DefaultBooleanOrShortWidthColumnWidth()}
                                    headerCell={TooltipCell}
                                />
                                <GridColumn
                                    key={"transactionDate"}
                                    field={"transactionDate"}
                                    title={"Transaction Date"}
                                    filter={"date"}
                                    format="{0:d}"
                                    width={DefaultBooleanOrShortWidthColumnWidth()}
                                    headerCell={TooltipCell}
                                />
                                <GridColumn
                                    key={"patient"}
                                    field={"patient"}
                                    title={"Patient"}
                                    width={DefaultBooleanOrShortWidthColumnWidth()}
                                    headerCell={TooltipCell}
                                />
                                <GridColumn
                                    key={"payer"}
                                    field={"payer"}
                                    title={"Payer"}
                                    width={DefaultBooleanOrShortWidthColumnWidth()}
                                    headerCell={TooltipCell}
                                />
                                <GridColumn
                                    key={"claimNumber"}
                                    field={"claimNumber"}
                                    title={"Claim Number"}
                                    width={DefaultBooleanOrShortWidthColumnWidth()}
                                    headerCell={TooltipCell}
                                />
                                <GridColumn
                                    key={"checkNumber"}
                                    field={"checkNumber"}
                                    title={"Check Number"}
                                    width={DefaultBooleanOrShortWidthColumnWidth()}
                                    headerCell={TooltipCell}
                                />
                                <GridColumn
                                    key={"checkDate"}
                                    field={"checkDate"}
                                    title={"Check Date"}
                                    width={DefaultBooleanOrShortWidthColumnWidth()}
                                    headerCell={TooltipCell}
                                />
                                {tabName !== "UnappliedCash" && (<GridColumn
                                    key={"adjudicatedCopay"}
                                    field={"adjudicatedCopay"}
                                    title={"Adjudicated Copay"}
                                    filter={"numeric"}
                                    width={DefaultBooleanOrShortWidthColumnWidth()}
                                    cells={{
                                        data: MoneyCell,
                                        footerCell: DetailsGridAggregateMoneyFooterCell,
                                    }}
                                    footerCell={DetailsGridAggregateMoneyFooterCell}
                                    headerCell={TooltipCell}
                                />)}
                                {tabName === "UnappliedCash" && (
                                    <GridColumn
                                        key={"adjudicatedCopay"}
                                        field={"adjudicatedCopay"}
                                        title={"Adjudicated Copay"}
                                        width={DefaultBooleanOrShortWidthColumnWidth()}
                                        headerCell={TooltipCell}
                                    />
                                )}
                                <GridColumn
                                    key={"paidCopay"}
                                    field={"paidCopay"}
                                    title={"Paid Copay"}
                                    width={DefaultBooleanOrShortWidthColumnWidth()}
                                    cells={{
                                        data: MoneyCell,
                                    }}
                                    headerCell={TooltipCell}
                                />
                                {tabName !== "UnappliedCash" && (
                                    <GridColumn
                                        key={"adjudicated"}
                                        field={"adjudicated"}
                                        title={"Adjudicated"}
                                        width={DefaultBooleanOrShortWidthColumnWidth()}
                                        filter={"numeric"}
                                        cells={{
                                            data: MoneyCell,
                                            footerCell: DetailsGridAggregateMoneyFooterCell,
                                        }}
                                        footerCell={DetailsGridAggregateMoneyFooterCell}
                                        headerCell={TooltipCell}
                                    />
                                )}
                                {tabName === "UnappliedCash" && (
                                    <GridColumn
                                        key={"adjudicated"}
                                        field={"adjudicated"}
                                        title={"Adjudicated"}
                                        width={DefaultBooleanOrShortWidthColumnWidth()}
                                        headerCell={TooltipCell}
                                    />
                                )}
                                <GridColumn
                                    key={"paid"}
                                    field={"paid"}
                                    title={"Paid"}
                                    width={DefaultBooleanOrShortWidthColumnWidth()}
                                    filter={"numeric"}
                                    cells={{
                                        data: MoneyCell,
                                        footerCell: DetailsGridAggregateMoneyFooterCell,
                                    }}
                                    footerCell={DetailsGridAggregateMoneyFooterCell}
                                    headerCell={TooltipCell}
                                />
                                <GridColumn
                                    key={"difference"}
                                    field={"difference"}
                                    title={"Difference"}
                                    width={DefaultBooleanOrShortWidthColumnWidth()}
                                    filter={"numeric"}
                                    cells={{
                                        data: MoneyCell,
                                        footerCell: DetailsGridAggregateMoneyFooterCell,
                                    }}
                                    footerCell={DetailsGridAggregateMoneyFooterCell}
                                    headerCell={TooltipCell}
                                />
                            </SharedMainSelectableClientGrid>
                        </Col>
                    </Row>
                </div>
            </DetailsModal>
            <PaymentExceptionDirectExport
                email={userContext.email}
                api={exportDetailsAPI()}
                apiParams={overPaymentDetailExportApiParams}
                apiType={tabName === 'UnappliedCash' ? "post" : "get"}
                directExportIsProcessing={directExportIsProcessing}
                setDirectExportIsProcessing={setDirectExportIsProcessing}
                directExportType={directExportType}
                exportFileName={"PaymentException" + tabName + "DetailsExport"}
                setIsDirectExportDataLoading={setIsDirectExportDataLoading}
            ></PaymentExceptionDirectExport>

            <IgnoreModal
                title="Ignore Details"
                show={showIgnoreModal}
                handleClose={() => {
                    return (
                        setShowIgnoreModal(false),
                        setDetailModelShow(false)
                    );
                }}
            >
                <ErrorHandler
                    error={IgnoreError}
                    onClose={() => {
                        setIgnoreError({});
                    }}
                />
                <IgnoreBody
                    selectedNcpdpIgnoreModalText={selectedNcpdpIgnoreModalText}
                    selectedRxIgnoreModalText={selectedRxIgnoreModalText}
                    handleCancelClick={handleCancelIgnoreClick}
                    selectedClidsToIgnore={selectedClidsToIgnore}
                    onSaveButtonClickCallbackFromParent={onIgnoreClaimsSaveButtonCallback}
                    onSuccessCallbackFromParent={onIgnoreClaimSuccessCallback}
                    disableControls={isIgnoreClaimsFormDisabled}
                    tabName={tabName}
                ></IgnoreBody>
            </IgnoreModal>
            {tabName != "UnappliedCash" &&
                <PrescriptionDetailsModal
                    auth={passedProps.auth}
                    clid={selectedClid}
                    show={showPrescriptionModal}
                    handleClose={handlePrescriptionDetailClose}
                    handleCellClick={handleCellClick}
                    user={userContext.email}
                />
            }
            {tabName == "UnappliedCash" &&
                <UnAppliedCashPrescriptionDetailsModal
                    auth={passedProps.auth}
                    pbid={selectedPbid}
                    rxNumber={selectedRxNumber}
                    dispensedDate={selectedDispensedDate}
                    show={showPrescriptionModal}
                    handleClose={handlePrescriptionDetailClose}
                    user={userContext.email}
                />
            }
        </div>)
}